import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatMoney } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { TrendingUp, TrendingDown, Wallet, Users, UserCog, ArrowUpRight, ArrowDownRight } from "lucide-react";
import { Link } from "react-router-dom";

function Stat({ label, value, sub, icon: Icon, tone = "neutral" }) {
  const toneCls = tone === "pos" ? "text-[--positive]" : tone === "neg" ? "text-[--negative]" : "text-zinc-900";
  return (
    <Card className="p-5 border border-zinc-200 shadow-none">
      <div className="flex items-start justify-between">
        <div className="text-xs uppercase tracking-widest text-zinc-500">{label}</div>
        {Icon && <Icon size={18} strokeWidth={1.5} className="text-zinc-400" />}
      </div>
      <div className={`mt-3 text-2xl number ${toneCls}`}>{value}</div>
      {sub && <div className="text-xs text-zinc-500 mt-1">{sub}</div>}
    </Card>
  );
}

export default function Dashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/analytics/dashboard").then((r) => setS(r.data)); }, []);
  if (!s) return <div className="text-zinc-500">Yükleniyor...</div>;
  return (
    <div className="space-y-8" data-testid="dashboard-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-zinc-500">Genel Bakış</div>
        <h1 className="text-3xl mt-1">Gösterge Paneli</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat label="Toplam Alacak" value={formatMoney(s.receivables)} sub="Müşteri alacakları" icon={ArrowUpRight} tone="pos" />
        <Stat label="Tedarikçi Borç" value={formatMoney(s.payables_suppliers)} sub="Tedarikçilere borç" icon={ArrowDownRight} tone="neg" />
        <Stat label="Çalışan Borç" value={formatMoney(s.payables_employees)} sub="Ödenmemiş maaş/bonus" icon={UserCog} tone="neg" />
        <Stat label="Kasa Toplamı" value={formatMoney(s.cash_total)} sub="Tüm kasalar" icon={Wallet} />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Stat label="Bu Ay Satış" value={formatMoney(s.sales_this_month)} icon={TrendingUp} tone="pos" />
        <Stat label="Bu Ay Alış" value={formatMoney(s.purchases_this_month)} icon={TrendingDown} tone="neg" />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {[
          {to:"/musteriler", label:"Müşteri", value:s.customer_count},
          {to:"/tedarikciler", label:"Tedarikçi", value:s.supplier_count},
          {to:"/calisanlar", label:"Çalışan", value:s.employee_count},
          {to:"/urunler", label:"Ürün", value:s.product_count},
          {to:"/kasalar", label:"Kasa", value:s.cash_register_count},
        ].map(x=>(
          <Link key={x.to} to={x.to} className="block">
            <Card className="p-4 border border-zinc-200 shadow-none hover:bg-zinc-50 transition-colors">
              <div className="text-xs uppercase tracking-widest text-zinc-500">{x.label}</div>
              <div className="text-xl number mt-2">{x.value}</div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
